import { Box, Stack, Typography } from "@mui/joy";
import { isLoggedIn } from "api/coachAuth";
import useMixpanelWeb from "hooks/useMixpanelWeb";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { userAtom } from "recoil/userAtom";
import { LogoWithTextSvg } from "static/image/common/SvgAssets";
import { isMobile } from "react-device-detect";
import { theme } from "styles/theme";
import FullPageContainer from "../container/FullPageContainer";
import CustomModal from "../../components/common/CustomModal";
import GoogleLoginButtonCoach from "components/user/GoogleLoginButtonCoach";

export default function LoginCoach() {
  const navigate = useNavigate();
  const user = useRecoilValue(userAtom);
  const { state } = useLocation();

  const containerRef = useRef<HTMLDivElement>(null);
  const [notCoachOpen, setNotCoachOpen] = useState(false);

  const setMixPanel_come = useMixpanelWeb({
    eventName: "로그인 페이지 진입",
    params: {
      type: isMobile ? "app" : "web",
      ...(user?.appId && { appId: user?.appId }),
    },
  });

  useEffect(() => {
    if (!isLoggedIn(user)) {
      setMixPanel_come();
      navigate("/coach", { replace: true });
    } else {
      // 이미 로그인이 되어 있다면 메인으로 이동
      navigate("/", { ...state, replace: true });
    }
  }, [user]);

  useEffect(() => {}, []);

  return (
    <FullPageContainer
      hasFooter={false}
      backgroundColor={theme.vars.palette.Background.Level2}
    >
      <Box sx={{ position: "absolute", top: 20, left: 20 }}>
        <LogoWithTextSvg />
      </Box>
      <Stack
        ref={containerRef}
        flexGrow={1}
        justifyContent="center"
        alignItems="center"
        gap={2}
        sx={{ width: "100%", maxWidth: "660px", mx: "auto", px: "20px" }}
      >
        <Stack alignItems="center" gap={4}>
          <Stack spacing={1} alignItems="center">
            <Typography
              variant="H1"
              sx={{
                color: theme.vars.palette.Content.Strong,
                fontWeight: 700,
              }}
            >
              {"코치 로그인"}
            </Typography>
            <Typography
              variant="Subtitle"
              sx={{
                color: theme.vars.palette.Content.Medium,
                fontWeight: 500,
              }}
            >
              {"디스턴싱 코치 계정으로 로그인합니다."}
            </Typography>
          </Stack>
          <GoogleLoginButtonCoach onNotCoach={() => setNotCoachOpen(true)} />
        </Stack>
      </Stack>
      <CustomModal
        open={notCoachOpen}
        onClose={() => {
          setNotCoachOpen(false);
        }}
        title={"로그인 실패"}
        subtitle={"등록된 코치가 아닙니다. 계정을 다시 확인해주세요."}
        actions={[
          {
            label: "확인",
            onClick: () => {
              setNotCoachOpen(false);
            },
            variant: "Solid",
          },
        ]}
      />
    </FullPageContainer>
  );
}
